/**
 * Compose the human-facing artifact title from a typed artifact's
 * `structured_content.title` block.
 *
 * The AI now emits a title object on structured (JSON) artifacts:
 *   { artifact_name, artifact_type, version }
 * e.g. { artifact_name: "JTBD - …", artifact_type: "JTBD", version: "V1" }
 *
 * The UI shows these joined as "artifact_name - artifact_type - version"
 * (only the parts that are present), used in the conversation artifact pill
 * and the artifacts list. Returns `null` when there is no usable title block,
 * so callers can fall back to their existing heading/humanised-name logic.
 */
export function composeArtifactTitle(
  structuredContent: Record<string, unknown> | null | undefined
): string | null {
  const title = (structuredContent as { title?: unknown } | null | undefined)?.title;
  if (!title || typeof title !== 'object') return null;

  const t = title as Record<string, unknown>;
  const pick = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

  const parts = [pick(t.artifact_name), pick(t.artifact_type), pick(t.version)].filter(Boolean);
  return parts.length ? parts.join(' - ') : null;
}
